import { gql } from '@apollo/client';

export const CREATE_CARD = gql`
  mutation Mutation($input: CardInput) {
    createCard(input: $input) {
      cardUrl
    }
  }
`;
